import { Link } from "react-router";

import states from "admin/routes.states";

const LinkComponent = ({ toState, parameters, children, ...rest }) => {
  let to = states[toState].url;
  rest.style = rest.style ? rest.style : {};
  rest.style.textDecoration = rest.style.textDecoration
    ? rest.style.textDecoration
    : "none";

  if (parameters)
    for (let i = 0; i < parameters.length; i++) to = `${to}/${parameters[i]}`;

  return (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
};

export default LinkComponent;
